export enum LoadDataTableBoard {
  NORMAL,
  CHANGE,
}

export enum TypeFilterLoadTableBoard {
  SST,
  SSTA,
  BOTH,
}


export enum TabViewSstTableBoard {
  GRAPHIC_TIME_SST,
  TABLE_PROGRAMMER_SST,
  GRAPHIC_PROGRAMMER_SST_FINISHED_SSTA,
}

export enum TabViewSstaTableBoard {
  GRAPHIC_TIME_SSTA,
  GRAPHIC_REJECTED_ACCEPTED_SSTA,
  TABLE_TRANSPORT_SSTA,
  TABLE_TRANSPORT_PENDING_TRIPS_SSTA,
  TABLE_PROGRAMMER_FINISHED_PENDING_SSTA,
}